const stations = [
    {
        title: 'آنکارا',
        code: 290,
        latitude: 3.9934906e1,
        longitude: 3.2843521e1,
        enTitle: 'ankara',
    },
    {
        title: 'تهران',
        code: 1,
        latitude: 3.5658142e1,
        longitude: 5.1398014e1,
        enTitle: 'tehran',
    },
    {
        title: 'کربلا',
        code: 512,
        latitude: 3.6031933e1,
        longitude: 5.0534222e1,
        enTitle: 'karbala',
    },
    {
        title: 'وان',
        code: 295,
        latitude: 3.8521908e1,
        longitude: 4.3382813e1,
        enTitle: 'van',
    },
];

export default stations.map(l => ({
    ...l,
    code: l.enTitle,
    stationId: l.code,
}));
